<template>
  <div class="documentation">
    <Breadcumb title="Modifier un tag" :breadcumb-data="breadcumbData"></Breadcumb>
    <b-card class="cardcontainer">
      <b-form @submit="editTag">
        <b-form-group label="Label en anglais" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
          <b-input type="text" placeholder="Label" v-model="label_en" :state="errors['label_en'] ? 'invalid': ''"/>
          <div v-if="errors['label_en']" class="invalid-tooltip">{{ errors['label_en'][0] }}</div>
        </b-form-group>
        <b-form-group label="Label en Français" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
          <b-input type="text" placeholder="Label français" v-model="label" :state="errors.label ? 'invalid': ''"/>
          <div v-if="errors['label']" class="invalid-tooltip">{{ errors['label'][0] }}</div>
        </b-form-group>
        <b-form-group label="Couleur" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
          <compact-picker v-if="colors.hex" v-model="colors" />
        </b-form-group>
          <div class="col-md-10 ml-md-auto">
            <b-btn type="submit" variant="primary">Editer le tag</b-btn>
          </div>
      </b-form>
    </b-card>
  </div>
</template>
<script>
  import {
    ADMIN_GET_TAG_REQUEST, ADMIN_UPDATE_TAG_REQUEST
  } from '../../_store/administration/questionnary/actiontypes'
  import { mapState } from 'vuex';
  import Breadcumb from '../../components/breadcumb';
  var vueColor = require('vue-color')

  export default {
    name: 'adminCategoryAdd',
    components: {
      'compact-picker': vueColor.Compact,
      Breadcumb
    },
    mounted() {
      this.$store.dispatch(ADMIN_GET_TAG_REQUEST, this.$route.params.id)
        .then(response => {
          this.label = response.data.tag.label;
          this.label_en = response.data.tag.label_en;
          this.tag_id = response.data.tag.id;
          console.log(response.data.tag.color);
          this.colors.hex = response.data.tag.color;
        })
    },
    computed: mapState({ errors: state => state.admin_document.errors }),
    data() {
      return ({
        breadcumbData: [
          { text: 'Accueil', href: '/dashboard/' },
          { text: 'Liste des questions', href: '/dashboard/administration/questionnary/' },
          { text: 'Modifier un tag', active: true },
        ],
        label_en: '',
        label: '',
        tag_id: '',
        colors: {}
      });
    },
    layout(context) {
      return 'layout';
    },
    methods: {
      editTag: function (e) {
        e.preventDefault();
        this.$store.dispatch(ADMIN_UPDATE_TAG_REQUEST, {
          label_en: this.label_en,
          label: this.label,
          id: this.tag_id,
          color: this.colors.hex
        })
          .then(() => {
            this.$router.push('/dashboard/administration/questionnary/');
          })
          .catch((error) => {
            console.log('error is ==');
            console.log(error);
          });
      }
    }
  };
</script>
